import React, { useState, useEffect } from "react";
import ButtonIcon from "../../components/ButtonIcon";
import DataGridView from "../components/DataGridView";
import { userData, selectedOptic } from "../../js/utils";
import { post } from "../utils/api";

import "../css/Fidelizacion.css";
import LoyaltyScreen from "../components/LoyaltyScreen";

const tokenSesion = userData ? userData.token : "";

let columnsData = [
  { name: "Id", accessor: "id", width: "60px", sortable: true },
  {
    name: "Nombre del perfil",
    accessor: "nombre",
    width: "0.5fr",
    sortable: false,
  },
  {
    name: "Ópticas vinculadas",
    accessor: "opticas",
    width: "1fr",
    sortable: true,
  },
  { name: "Opción", accessor: "tipoAsignacion", width: "1fr", sortable: true },
];

export default function Fidelizacion(props) {
  const [profilesList, setProfileList] = useState([]);
  const [idPerfil, setIdPerfil] = useState(-1);

  const [isProfileOpen, setIsProfileOpen] = useState(false);

  async function loadProfiles() {
    let profilesData = [];
    let profilesJSON = [];
    let jsonQuery = { token: tokenSesion, idOptica: selectedOptic.id };

    profilesJSON = await post(
      "Configuracion/ListarConfiguracionFidelizaciones.php",
      jsonQuery,
    );

    if (Array.isArray(profilesJSON)) {
      for (const el of profilesJSON) {
        console.log("Perfil Fid: ", el);
        let profile = {
          id: el.id,
          nombre: el.nombre,
          opticas: el.opticas,
          tipoAsignacion: el.tipoAsignacion,
        };

        profilesData.push(profile);
      }

      setProfileList(profilesData);
    }
  }

  useEffect(() => {
    loadProfiles();
  }, []);

  const newProfile = () => {
    setIdPerfil(-1);
    setIsProfileOpen(true);
  };

  const openProfilePopup = (row) => {
    setIdPerfil(row.id);
    setIsProfileOpen(true);
  };

  const closeProfilePopup = () => {
    setIsProfileOpen(false);
  };

  if (!props.show) {
    return <></>;
  }

  return (
    <>
      <div className="settings-body-container">
        <div className="empresas-opticas">
          <span className="title-h2">Fidelización</span>
          <div className="empresas-opticas-options">
            <div className="general-header-separator" />
            <ButtonIcon
              text="Nuevo perfil"
              icon="/images/add-white.svg"
              onClick={() => {
                newProfile();
              }}
            />
          </div>
        </div>
        <DataGridView
          columns={columnsData}
          data={profilesList}
          onRowClick={openProfilePopup}
          keyField="id"
          itemsIncrement="15"
        />
      </div>
      {isProfileOpen && (
        <LoyaltyScreen
          {...props}
          show={isProfileOpen}
          idPerfil={idPerfil}
          closeFunction={closeProfilePopup}
          onSave={(newId) => {
            if (newId) setIdPerfil(newId);
            loadProfiles();
          }}
          onDelete={() => {
            loadProfiles();
          }}
        />
      )}
    </>
  );
}
